import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GungBase } from 'gung-standard';
import { Observable } from 'rxjs';

export interface Claim /* extends GungBase */ {
  id?: string;
  customerId: string;
  extra: {
    ork: {
      rmanr: string;
      kundreklamationorsak: string;
      claimworkflow: string;
      q_artserienr: string;
      q_dotnr: string;
      q_kvar_monster: string;
      edit: string;
      saljare: string;
      ordernr: string;
      faktnr: string;
      claimqty: string;
      eventnote: string;
      artnr: string;
      ftgnr: string;
      foretagkod: string;
      q_fleet: boolean;
      q_bosspl: boolean;
      q_kompletthjul: boolean;
      q_falg: boolean;
      claimactivitystatus: string;
    };
  };
}

@Injectable({
  providedIn: 'root'
})
export class ColmecClaimService {
  baseUrl = 'json/colmec/claims';

  constructor(protected http: HttpClient) { }

  getAllClaims(): Observable<Claim[]> {
    const url = `${this.baseUrl}/list`;
    return this.http.get<Claim[]>(url);
  }

  getClaims(customerId: string): Observable<Claim[]> {
    const url = `${this.baseUrl}/list-by-customer-id/${customerId}`;
    return this.http.get<Claim[]>(url);
  }

  postClaim(customerId: string, claim: Claim): Observable<any> {
    const url = `${this.baseUrl}/create-claim/${customerId}`;
    return this.http.post<any>(url, claim);
  }
}
